module.exports = __webpack_public_path__ + "img/sec555.6194cc37.jpg";